import cx from 'classnames';
import { motion, useReducedMotion } from 'framer-motion';
import _ from 'lodash';
import { HTMLAttributes } from 'react';
import css from './SegmentChart.module.scss';

export interface ISegmentChartData {
  color: string;
  value: number;
}

export interface ISegmentChartProps extends HTMLAttributes<HTMLDivElement> {
  data: ISegmentChartData[];
  size?: 'sm' | 'lg';
}

export const SegmentChart = ({ className, data, size }: ISegmentChartProps) => {
  const prefersReducedMotion = useReducedMotion();

  const chartMotionProps = {
    initial: prefersReducedMotion ? 'show' : 'hide',
    animate: 'show',
    variants: {
      show: {
        transition: {
          staggerChildren: 0.03,
        },
      },
    },
  };

  const fillMotionProps = {
    transition: {
      duration: 0.45,
      ease: [0.42, 0, 0.01, 1],
    },
    variants: {
      hide: { opacity: 0, width: 'inherit' },
      show: {
        opacity: 1,
        width: '100%',
      },
    },
  };

  const total = _.sumBy(data, 'value');

  return (
    <motion.div
      className={cx(css.segmentChart, css[size], className)}
      {...chartMotionProps}
    >
      {_.map(data, ({ color, value }, i) => {
        const width = total > 0 ? (value / total) * 100 + '%' : '33%';
        return (
          <div
            key={i}
            className={cx(css.segment, {
              [css.reducedMotion]: prefersReducedMotion,
            })}
            style={{ width }}
          >
            <motion.div
              className={css.segmentFill}
              style={{ backgroundColor: color }}
              {...fillMotionProps}
            />
          </div>
        );
      })}
    </motion.div>
  );
};
